import { SelectDepth } from 'components';
import { useGetProductCategories } from 'hooks/ProductCategoryHooks';
import { useEffect, useState, useCallback } from 'react';

const ProductCategoryForm = ({ onSelectCategory, categoryId }) => {
  const { data: response } = useGetProductCategories({ type: 'PRODUCT' });
  const [productCategories, setProductCategories] = useState([]);

  useEffect(() => {
    if (response && response.status === 200) {
      const { data } = response;
      setProductCategories(buildHierarchy(data));
    }
  }, [response]);

  const buildHierarchy = (data) => {
    const idMap = {};
    const root = [];

    data.forEach((item) => {
      idMap[item.product_category_id] = {
        key: item.product_category_id,
        title: item.product_category_name,
        children: [],
        ...item,
      };
    });

    data.forEach((item) => {
      if (item.parents_id === null) {
        // parent_id가 null이면 root에 추가
        root.push(idMap[item.product_category_id]);
      } else {
        // parent_id가 존재하면 부모의 children에 추가
        const parent = idMap[item.parents_id];
        if (parent) {
          parent.children.push(idMap[item.product_category_id]);
        }
      }
    });
    return root;
  };

  const handleSelect = useCallback((categories) => {
    if (Array.isArray(categories) && categories.length > 0) {
      const selectedCategory = categories[categories.length - 1];
      if (onSelectCategory) {
        onSelectCategory(selectedCategory.product_category_id);
      }
    }
  }, []);

  return (
    <SelectDepth
      items={productCategories}
      onSelect={handleSelect}
      defaultCategoryId={categoryId}
    />
  );
};

export default ProductCategoryForm;
